import { render } from "./FatturaVoci.vue?vue&type=template&id=7bc67304"
import script from "./FatturaVoci.vue?vue&type=script&lang=js"
export * from "./FatturaVoci.vue?vue&type=script&lang=js"

import "./FatturaVoci.vue?vue&type=style&index=0&id=7bc67304&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__